import { isCustomerVerified } from '@/lib/validation'
import type { Customer } from '@/api/types'

/**
 * Start-/skapelsedatumet ska baseras på Hitrate-datumet, inte vårt egna created_at.
 * En backfill kan sätta ett färskt created_at på en kund som egentligen skapades för länge sedan.
 */
export function getCustomerStartDate(customer: Customer): string {
  return customer.hitrate_created_at ?? customer.created_at
}

export function formatCustomerNumber(customerId: number): string {
  return `Kund nr ${customerId}`
}

export function getCustomerName(customer: Customer): string {
  const name = `${customer.first_name ?? ''} ${customer.last_name ?? ''}`.trim()

  if (name.length === 0) {
    return 'Okänd kund'
  }

  return name
}

// Bara kunder med abonnemang som inte redan skickar, och som motorn faktiskt plockar upp – den bokar aldrig frakt åt en ovaliderad kund.
export function canActivateShipments(customer: Customer): boolean {
  return customer.subscription !== null && customer.subscription.enable_postnord === false && isCustomerVerified(customer)
}

export function canEnableInvoicing(customer: Customer): boolean {
  return customer.subscription !== null && customer.subscription.enable_capway === false && isCustomerVerified(customer)
}
